import React from 'react'
import { Link } from "react-router-dom";
import SliderHomeGallery from '../../component/slidercomponent/SliderHomeGallery';


const HomeGallery = () => {
    return (
        <>
            <section className="renvia-team-sec pt-120 pb-80" style={{ marginTop: "-190px" }}>
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-lg-10">
                            <div className="section-title text-center mb-45">
                                <span className="sub-title aos-init aos-animate" data-aos="fade-down" data-aos-duration={1000}><img src="assets/images/line1.png" alt="line" />Running Project Gallery<img src="assets/images/line2.png" alt="line" /></span>
                                <h2 className="text-anm" aria-label="Worldwide executive leadership">
                                    Watch Our Latest Project Videos
                                </h2>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-xl-3 col-md-6 col-sm-12">
                            <div className="renvia-team-item style-one mb-40 aos-init aos-animate" data-aos="fade-up" data-aos-duration={1000}>
                                <div className="member-image">
                                    <iframe width={560} height={300} src="https://www.youtube.com/embed/4C__0vWUZnM?si=oaSaeh6_TorEHeiJ" title="YouTube video player" frameBorder={0} allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerPolicy="strict-origin-when-cross-origin" allowFullScreen />

                                </div>
                            </div>
                        </div>
                        <div className="col-xl-3 col-md-6 col-sm-12">
                            <div className="renvia-team-item style-one mb-40 aos-init aos-animate" data-aos="fade-up" data-aos-duration={1200}>
                                <div className="member-image">
                                    <iframe width="560" height="300" src="https://www.youtube.com/embed/W_U91LbEgnI?si=fw-OMVynpttmVDNP" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                                </div>
                            </div>
                        </div>
                        <div className="col-xl-3 col-md-6 col-sm-12">
                            <div className="renvia-team-item style-one mb-40 aos-init aos-animate" data-aos="fade-up" data-aos-duration={1400}>
                                <div className="member-image">
                                    <iframe width="560" height="300" src="https://www.youtube.com/embed/i0BNmzPPLns?si=XsUk9bfPVApNRJlY" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                                </div>
                            </div>
                        </div>
                        <div className="col-xl-3 col-md-6 col-sm-12">
                            <div className="renvia-team-item style-one mb-40 aos-init aos-animate" data-aos="fade-up" data-aos-duration={1600}>
                                <div className="member-image">
                                    <iframe width="560" height="300" src="https://www.youtube.com/embed/ZgbcXGDHuDw?si=NZJ8_ms8VmreJopW" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            
        </>
    )
}

export default HomeGallery